import { take, takeLatest, fork, put, cancel, cancelled } from 'redux-saga/effects';
import ky from 'ky-universal';
import { schema, normalize } from 'normalizr';

import { chocomemberHost, chocotvWeb } from '../../config/api';
import { AUTH_STATE_LOGIN } from '../../constants';
import { AUTH_FLOW_END, LOGOUT, FETCH_POLICIES_SUCCEEDED, UPDATE_POLICIES } from '../constants/actionTypes';
import authUtils from '../utils/auth';

function* fetchPolicies() {
  const abortController = new AbortController();

  try {
    const res = yield ky.get(`${chocomemberHost}/account/policies`, {
      searchParams: {
        appId: chocotvWeb.chocomemberAppId,
        chocolabsAppId: chocotvWeb.appId,
      },
      headers: {
        Authorization: authUtils.getAccessToken(),
      },
      signal: abortController.signal,
    });

    const { data } = yield res.json();

    const policiesSchema = [new schema.Entity('policies')];

    yield put({ type: FETCH_POLICIES_SUCCEEDED, payload: normalize(data, policiesSchema) });
  } finally {
    if (yield cancelled()) {
      abortController.abort();
    }
  }
}

export function* fetchPoliciesFlow() {
  while (true) {
    const { payload } = yield take(AUTH_FLOW_END);

    if (payload === AUTH_STATE_LOGIN) {
      const task = yield fork(fetchPolicies);
      yield take(LOGOUT);
      yield cancel(task);
    }
  }
}

function* updatePolicies({ payload }) {
  if (!Array.isArray(payload)) return;

  const abortController = new AbortController();

  try {
    yield ky.post(`${chocomemberHost}/account/policies`, {
      json: {
        appId: chocotvWeb.chocomemberAppId,
        chocolabsAppId: chocotvWeb.appId,
        policies: payload,
      },
      headers: {
        Authorization: authUtils.getAccessToken(),
      },
      signal: abortController.signal,
      throwHttpErrors: false,
    });
  } finally {
    if (yield cancelled()) {
      abortController.abort();
    }
  }
}

export function* updatePoliciesFlow() {
  while (true) {
    const { payload } = yield take(AUTH_FLOW_END);

    if (payload === AUTH_STATE_LOGIN) {
      yield take(FETCH_POLICIES_SUCCEEDED);
      const task = yield takeLatest(UPDATE_POLICIES, updatePolicies);
      yield take(LOGOUT);
      yield cancel(task);
    }
  }
}
